import { render, staticRenderFns } from "./ClinicShowTemplate.vue?vue&type=template&id=356699a9"
import script from "./ClinicShowTemplate.vue?vue&type=script&lang=js"
export * from "./ClinicShowTemplate.vue?vue&type=script&lang=js"
import style0 from "./ClinicShowTemplate.vue?vue&type=style&index=0&id=356699a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports